import { title } from 'process';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any, arg: any): any {
    const resultPosts= [];
    for(const listado of value){
      if(listado.carnet.toString().indexOf(arg)>-1){
        //console.log("entra");
        resultPosts.push(listado);
      }
    }
    return resultPosts;
  }

}
